/* eslint-disable */
// WARNING: this file is generated by a script, don't change it manually!
import { SvgIcon, SvgIconProps } from "@mui/material";
import * as React from "react";
const Remove: React.FC<SvgIconProps> = (props) => <SvgIcon {...props} data-testid="OriginRemoveIcon"><path fill="currentColor" d="M6 13a.97.97 0 0 1-.713-.287A.97.97 0 0 1 5 12q0-.424.287-.713A.97.97 0 0 1 6 11h12q.424 0 .712.287.288.288.288.713 0 .424-.288.713A.97.97 0 0 1 18 13z" /></SvgIcon>;
export default Remove;